import { createSelector } from 'reselect'
import moment from 'moment'
import { toHslaString } from '@imodules/react-components/forms/shared'

export const getAffiliationConfiguration = (state: RootState) => state.affiliation

export const getAffiliationInstanceSettings = createSelector(getAffiliationConfiguration, affiliationConfiguration => affiliationConfiguration && affiliationConfiguration.instanceSettings)

export const getAffiliationDisplayEndDateTime = createSelector(getAffiliationInstanceSettings, settings => settings && settings.displayEndDateTime && moment(settings.displayEndDateTime))

export const getAffiliationDisplayStartDateTime = createSelector(getAffiliationInstanceSettings, settings => settings && moment(settings.displayStartDateTime))

export const getTitleTextStyle = createSelector(getAffiliationInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.titleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.titleColor),
    fontStyle: instanceSettings.layoutSettings.titleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.titleBold ? 'bold' : 'normal',
})

export const getSubTitleTextStyle = createSelector(getAffiliationInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.subTitleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.subTitleColor),
    fontStyle: instanceSettings.layoutSettings.subTitleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.subTitleBold ? 'bold' : 'normal',
})

export const getLabelTextStyle = createSelector(getAffiliationInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.labelFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.labelColor),
    fontWeight: instanceSettings.layoutSettings.labelBold ? 'bold' : 'normal',
})

export const getPercentageTextStyle = createSelector(getAffiliationInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.percentageFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.percentageColor),
    fontWeight: instanceSettings.layoutSettings.percentageBold ? 'bold' : 'normal',
})

export const getShowModule = createSelector(getAffiliationDisplayEndDateTime, getAffiliationDisplayStartDateTime, (displayEndDateTime, displayStartDateTime) =>
    moment().isAfter(displayStartDateTime) && (!displayEndDateTime || moment().isBefore(displayEndDateTime)))
